// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { AppShell } from '@mantine/core';
import { useContext, useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import { IconFilter, IconInbox } from '@tabler/icons';
import { WindowContext } from '../../Service/Context/WindowContext';
import DoubleNavbar from '../../Molecules/DoubleNavbar';
import PageHeader from '../Navigation/PageHeader';
import { RoutingS } from '../../Service/RoutingS';
import { PostboxCountersProvider } from '../../Service/Context/PostboxCountersContext';
import NavDrawer from '../../Atoms/NavDrawer';
import BookitupFooter from '../Navigation/phone/BookitupFooter';
import { MessageContext } from '../../Service/Context/MessageContextV2';
import EmailInboxNavLinks from './EmailInboxNavLinks';
import InboxPageFooter from '../Navigation/phone/InboxPageFooter';

const EmailInboxPage = () => {
  const { sm } = useContext(WindowContext);
  const [drawerOpened, setDrawerOpened] = useState(false);
  const { initMessage } = useContext(MessageContext);

  useEffect(() => {
    RoutingS.changeTitle('Postfach');
  }, []);

  return (
    <PostboxCountersProvider>
      <AppShell
        header={<PageHeader />}
        navbar={
          sm ? undefined : (
            <DoubleNavbar>
              <EmailInboxNavLinks closeNavBar={() => setDrawerOpened(false)} />
            </DoubleNavbar>
          )
        }
        styles={(theme) => ({
          main: { backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'inherit', width: '100%' },
        })}
        footer={
          sm ? (
            <BookitupFooter>
              <InboxPageFooter filter={() => setDrawerOpened(true)} addHandler={initMessage} />
            </BookitupFooter>
          ) : undefined
        }
      >
        {sm && (
          <NavDrawer
            label="Postfächer"
            icon={<IconInbox size={32} />}
            opened={drawerOpened}
            onClose={() => setDrawerOpened(false)}
          >
            <EmailInboxNavLinks closeNavBar={() => setDrawerOpened(false)} />
          </NavDrawer>
        )}
        <Outlet />
      </AppShell>
    </PostboxCountersProvider>
  );
};

export default EmailInboxPage;
